// extracted by mini-css-extract-plugin
export var change = "_49-1";
export var changeList = "_49-0";
export var changePath = "_49-2";
export var diffArrow = "_49-5";
export var diffRow = "_49-3";
export var diffValue = "_49-4";
export var error = "_49-8";
export var notice = "_49-9";
export var result = "_49-6";
export var success = "_49-7";